import * as React from 'react';

import { TypographyI18n } from 'components/v2';
import { generateMessageTemplateKey } from 'hooks';
import CancelButtonContainer from '../CancelButtonContainer';

type Props = {
  onClick: () => void;
  disabled: boolean;
};

const CancelButtonInitial = (props: Props) => {
  const { disabled, onClick } = props;

  return (
    <CancelButtonContainer onClick={onClick} disabled={disabled}>
      <TypographyI18n variant="bW600F14" color="inherit" noWrap>
        {generateMessageTemplateKey('patientLumaBotManageAppointmentCancelAppointment')}
      </TypographyI18n>
    </CancelButtonContainer>
  );
};

export default CancelButtonInitial;
